import { BORDER_COLOR, COL_ONE_WIDTH } from "components/utility/pdf/utility/pdfConstants";
import { cleanText, styleElement } from "components/utility/pdf/utility/pdfUtilityFunctions";

export const createImageComponentDocDef = (image, node, areThereAuthors) => {
	const imageComponentFirstInContent = node.matches(":first-child");
	let topBorderWidth = 0,
		topBorderMargin = 0,
		imageTopMargin = 15,
		bottomBorderWidth = 0,
		imageComponentStack = [];

	// top border
	if (node.classList.contains("content-page-module-image--border-top")) {
		topBorderWidth = 400;
		topBorderMargin = 15;
		imageTopMargin = 15;
		if (imageComponentFirstInContent) {
			topBorderMargin = areThereAuthors ? -28 : -9;
		}
		imageComponentStack.push({
			canvas: [
				{
					type: "line",
					x1: 0,
					y1: 0,
					x2: topBorderWidth,
					y2: 0,
					lineWidth: 1,
					lineColor: BORDER_COLOR
				}
			],
			margin: [0, topBorderMargin, 0, 0]
		});
	}
	// go through each child of <div class="content-page-module-image"/>
	[...node.children].forEach((childNode) => {
		if (childNode.querySelector("img")) {
			const imageTag = childNode.querySelector("img");
			let bottomImageMargin = 15;
			let imageLink;
			// if the image is wrapped in an anchor tag add an image link
			const imageAnchorTag = imageTag.closest("A");
			if (imageAnchorTag) {
				imageLink = imageAnchorTag.href;
			}
			// if there is no border and the image component is the first in the content column and image is first within the image component
			if (!topBorderWidth && imageComponentFirstInContent && imageComponentStack.length === 0) {
				imageTopMargin = areThereAuthors ? -28 : -9;
			}
			// if image is last within the image component and the image component is the first in the content column
			if (imageComponentFirstInContent && childNode === childNode.parentElement.lastElementChild) {
				bottomImageMargin = areThereAuthors ? 48 : 29;
			}
			if (image)
				imageComponentStack.push({
					image: image.pngDataUrl,
					fit: [image.fitWidth, image.fitHeight],
					margin: [0, imageTopMargin, 0, bottomImageMargin],
					...(imageLink && { link: imageLink })
				});
		}
		if (childNode.classList.contains("pdf--image-title")) {
			let titleTopMargin = 0,
				titleBottomMargin = 10;
			// if the order of the component is border, title, desc, image
			if (imageComponentStack.length === 1) titleTopMargin = 15;
			// if the title comes first and there's no border and if image component is first in the content column
			if (imageComponentStack.length === 0 && imageComponentFirstInContent)
				titleTopMargin = areThereAuthors ? -28 : -9;
			// if title is last item in image component and image component is firs tin the content column
			if (childNode === childNode.parentElement.lastElementChild && imageComponentFirstInContent) {
				titleBottomMargin = areThereAuthors ? 48 : 20;
			}
			imageComponentStack.push({
				margin: [0, titleTopMargin, 0, titleBottomMargin],
				text: childNode.innerText.toUpperCase(),
				style: "subhead-1"
			});
		}
		if (childNode.classList.contains("pdf--image-description")) {
			let descTopMargin = 0,
				descBottomMargin = 10;
			// if image component is first in the content column and description is first in the image component
			if (imageComponentFirstInContent && imageComponentStack.length === 0)
				descTopMargin = areThereAuthors ? -28 : -9;
			// if desc is second in image component and the first item is border top
			if (
				imageComponentStack.length === 1 &&
				Object.keys(imageComponentStack[0]).includes("canvas")
			)
				descTopMargin = 10;
			// if image component is first in the content column and description is last in the image component
			if (childNode === childNode.parentElement.lastElementChild && imageComponentFirstInContent) {
				descBottomMargin = areThereAuthors ? 48 : 20;
			}
			let styledDesc = [];
			let fragment = document
				.createRange()
				.createContextualFragment(cleanText(childNode.innerHTML));
			fragment.childNodes.forEach((fragmentNode) => {
				styledDesc.push({ text: styleElement(fragmentNode, "default", false) });
			});
			imageComponentStack.push({
				stack: styledDesc,
				margin: [0, descTopMargin, 0, descBottomMargin]
			});
		}
		if (childNode.querySelector("[data-tip]")) {
			let tooltipBottomMargin = 20;
			// if image component first in content column and there is no border bottom
			if (
				imageComponentFirstInContent &&
				!childNode.parentNode.lastElementChild.classList.contains(
					"content-page-module-image--border-bottom"
				)
			) {
				tooltipBottomMargin = areThereAuthors ? 48 : 29;
			}
			// if there is a border bottom
			if (
				childNode.parentNode.lastElementChild.classList.contains(
					"content-page-module-image--border-bottom"
				)
			) {
				tooltipBottomMargin = 0;
			}
			let styledToolTipData = [];
			const tooltipData = childNode.querySelector("[data-tip]").getAttribute("data-tip");
			let fragment = document.createRange().createContextualFragment(cleanText(tooltipData));
			fragment.childNodes.forEach((fragmentNode) => {
				styledToolTipData.push({
					text: styleElement(fragmentNode, "exhibit-disclosure", false)
				});
			});
			imageComponentStack.push({
				stack: styledToolTipData,
				margin: [0, 20, 0, tooltipBottomMargin]
			});
		}

		if (childNode.classList.contains("content-page-module-image--border-bottom")) {
			bottomBorderWidth = 400;
			// if there are authors add the -28 to the bottom of this border
			const borderBottomMargin = imageComponentFirstInContent && areThereAuthors ? 48 : 20;
			imageComponentStack.push({
				canvas: [
					{
						type: "line",
						x1: 0,
						y1: 0,
						x2: bottomBorderWidth,
						y2: 0,
						lineWidth: 1,
						lineColor: BORDER_COLOR
					}
				],
				margin: [0, bottomBorderWidth ? 15 : 0, 0, borderBottomMargin]
			});
		}
	});

	return {
		unbreakable: true,
		stack: [
			{
				columns: [
					{
						width: COL_ONE_WIDTH,
						stack: []
					},
					{
						width: "*",
						stack: [...imageComponentStack]
					}
				]
			}
		]
	};
};
